__turbopack_context__.v({
  "animated": "styles-module__fQIEva__animated",
  "controlLabel": "styles-module__fQIEva__controlLabel",
  "controls": "styles-module__fQIEva__controls",
  "demo": "styles-module__fQIEva__demo",
  "description": "styles-module__fQIEva__description",
  "fill": "styles-module__fQIEva__fill",
  "header": "styles-module__fQIEva__header",
  "imageClip": "styles-module__fQIEva__imageClip",
  "instant": "styles-module__fQIEva__instant",
  "mockup": "styles-module__fQIEva__mockup",
  "rangeInput": "styles-module__fQIEva__rangeInput",
  "reducedMotion": "styles-module__fQIEva__reducedMotion",
  "root": "styles-module__fQIEva__root",
  "rtl": "styles-module__fQIEva__rtl",
  "selectInput": "styles-module__fQIEva__selectInput",
  "smear": "styles-module__fQIEva__smear",
  "smearInner": "styles-module__fQIEva__smearInner",
  "title": "styles-module__fQIEva__title",
});
